import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { RmEvaluationInfo } from '../dto/rm-evaluation.dto';
import { RmEvaluationAdapter } from '../dto/rm-evaluation.adapter';
import { RmEvaluationSamples } from '../rm-evaluation-samples.entity';
import { RmEvaluation } from '../rm-evaluation.entity';
import { RmEvaluationSamplesInfo } from '../dto/rm-evaluation-samples.dto';
import { RmEvaluationSamplesAdapter } from '../dto/rm-evaluation-samples.adapter';
import { Grn } from '../raw-material-grn.entity';
import { GrnRequest } from '../dto/raw-material-grn.request';
import { RmEvaluationResponse } from '@gtpl/shared-models/raw-material-procurement';
import { RmEvaluationRepository } from '../rm-evaluation.repository';
import { VehicleService } from '@gtpl/shared-services/masters';
import { VehicleRequest } from '@gtpl/shared-models/masters';
import { RmEvaluationDto } from '@gtpl/shared-models/raw-material-procurement';
import { GrnItems } from '../raw-material-grn-items.entity';
import { RMGrnItemIdReq } from '../dto/grn-item-id.request';
@Injectable()
export class RmEvaluationService {
    constructor(
        @InjectRepository(RmEvaluationSamples)
        private RmESamplesRepo: Repository<RmEvaluationSamples>,
        @InjectRepository(RmEvaluation)
        private RmErepository: Repository<RmEvaluation>,
        private RmEAdapter: RmEvaluationAdapter,
        private RmESamplesAdapter: RmEvaluationSamplesAdapter,
        private RmRepo: RmEvaluationRepository,
        private vehicleService: VehicleService
    ) { }

    async createRmEvaluationInfo(rmInfo: RmEvaluationInfo): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const samplesData: RmEvaluationSamples[] = [];
            const convertedDtoRmE = await this.RmEAdapter.convertDtoToEntity(rmInfo);
            const savedInfoRmE = await manager.getRepository(RmEvaluation).save(convertedDtoRmE);

            if (savedInfoRmE) {
                const updateGrn = await manager.getRepository(GrnItems).update({ grnItemId: savedInfoRmE.grnItemId }, { isRmInspectionCompleted: true });
                if (updateGrn.affected) {
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'RM Evaluation Info along with Samples Info are created successfully');
                } else {
                    throw new ErrorResponse(9999, 'Failed to update RM GRN');
                }
            } else {
                throw new ErrorResponse(9999, 'Creation of Rm Evaluation failed');
            }
        } catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }

    async getRmEvaluationInfoUsingGrnId(req:RMGrnItemIdReq): Promise<RmEvaluationResponse> {
        try {
            const rmEvalSamplesData: RmEvaluationSamplesInfo[] = [];
            const rmEvalEntity = await this.RmRepo.getRmEvalData(req.grnItemId);

            if (rmEvalEntity) {
                const rmEvalData = this.RmEAdapter.convertEntityToDto(rmEvalEntity);
                const req = new VehicleRequest(rmEvalData.vehicleId);
                const vehicleData = await this.vehicleService.getVehicleByVehId(req);
                if (vehicleData) {
                    const rmEvalDto = new RmEvaluationDto(rmEvalData.rmEvaluationId, rmEvalData.grnId, rmEvalData.vehicleId, vehicleData.data.registrationNumber, rmEvalData.arrivalTime, rmEvalData.startTimeOfObv, rmEvalData.freqencyOfInsp, rmEvalData.batchNumber, rmEvalData.centerOrSourceCode, '', rmEvalData.totalQuantity, rmEvalData.noOfSamplesDrawn, rmEvalData.remarks, rmEvalData.RmEvalSamplesInfo, rmEvalData.createdAt, rmEvalData.createdUser, rmEvalData.updatedAt, rmEvalData.updatedUser, rmEvalData.versionFlag)
                    const response = new RmEvaluationResponse(true, 1, 'RM Evaluation Info and Samples Retrieved Successfully', rmEvalDto);
                    return response;
                } else {
                    throw new ErrorResponse(99998, 'Evaluation Samples Not Found');
                }
            } else {
                throw new ErrorResponse(99998, 'RM Evaluation details for the grn Id are not found');
            }
        } catch (error) {
            return error;
        }
    }

}